<div class="audit-trail">
  <div class="static-info">
    @for (info of staticInfo; track info) {
      @if (info.shouldDisplay !== false) {
        <div class="info">
          <span class="info-label">{{ info.label }}</span>
          @if (info?.value && !info.user) {
            <div class="info-value">
              <span>{{ info?.value }}</span>
              @if (info.copyToClipboard) {
                <sui-button
                  variant="primary"
                  [leadingIcon]="['fas', 'copy']"
                  [iconOnly]="true"
                  ariaLabel="Copy to clipboard"
                  (click)="copyToClipboard(info.value)"
                ></sui-button>
              }
            </div>
          }
          @if (
            info?.value?.avatar_url && info?.value?.name && info?.value;
            as v
          ) {
            <div class="info-value">
              @if (v?.avatar_url) {
                <img
                  [src]="v.avatar_url"
                  style="width: 2.857rem; height: 2.857rem; border-radius: 50%"
                />
              }
              <span>{{ v?.name }}</span>
            </div>
          }
        </div>
      }
    }
  </div>
  <app-user-activity-logs
    [objectId]="object.id"
    [objectClassId]="
      hasCharts ? NomObjectClass.WIDGET : (object.object_class_id ?? null)
    "
    [activeCompanyId]="$safeNavigationMigration(user?.active_company_id)"
    [isAuditTrail]="true"
  ></app-user-activity-logs>
</div>
